import { UserMappingRole } from '../../api/generated/v2/incident';

export class UserMappingRoleUtils {
  public static readonly USER_MAPPING_TYPES = [
    {
      key: UserMappingRole.ConstructionCoordination,
      label: 'Baukoordination'
    },
    {
      key: UserMappingRole.OperationsService,
      label: 'Betriebsservice'
    },
    {
      key: UserMappingRole.ExternalServiceProvider,
      label: 'Externer Dienstleister'
    },
    {
      key: UserMappingRole.Sales,
      label: 'Fachvertrieb'
    },
    {
      key: UserMappingRole.TechnicalInsideSales,
      label: 'Innendienst'
    },
    {
      key: UserMappingRole.InternalInstaller,
      label: 'Interner Monteur'
    },
    {
      key: UserMappingRole.Foreman,
      label: 'Meister'
    },
    {
      key: UserMappingRole.ProjectPlanning,
      label: 'Projektierung'
    }
  ];
}
